module.exports = __webpack_public_path__ + "static/room6-b38843f6d3ef8089b59324f7abc7d497.jpg";